import { render } from "./FeatureConfigs.vue?vue&type=template&id=73d8ef24&scoped=true"
import script from "./FeatureConfigs.vue?vue&type=script&lang=js"
export * from "./FeatureConfigs.vue?vue&type=script&lang=js"

import "./FeatureConfigs.vue?vue&type=style&index=0&id=73d8ef24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d8ef24"]])

export default __exports__